"use strict";

import getNgModule from "getNgModule";

const ngModule = getNgModule(__filename);

ngModule.directive("obsSdisSearchField", function () {
    return {
        restrict: "E",
        require: "^obsSdisManager",
        replace: true,
        template: '' +
            '<div class="obs-search-field">' +
            '   <tl-search-field config="searchConfig"></tl-search-field>' +
            '</div>',
        link: function ($scope, $el, $attrs, mapManagerCtrl) {

            let obsConfig = $scope.observatoryConfig,
                searchUrl = obsConfig.resourceBaseUrl + "/search";

            $scope.searchExtraParams = {actuelsSeulement: true};

            $scope.searchConfig = {
                labelAttribute: "nom",
                extraParams: "searchExtraParams",
                searchUrl: searchUrl,
                resultTemplate: "" +
                    '<span class="name" ng-bind-html="result.nom | underlineSearchResultMatch:search.q"></span>' +
                    '<span class="dept">{{result.departement}}</span>',
                onSelect: function (commune) {
                    mapManagerCtrl.onSearchFieldSelection(commune);
                }
            };

        }
    };
});


// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/maps/sdis/obsSdisSearchField.js